module.exports = __webpack_public_path__ + "static/img/logo-todomath-for-web-en@3x.05808a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-todomath-for-web-en@3x.png
// module id = mUGf
// module chunks = 18